import { AppBar, AppBarProps, Avatar, Box, Button, experimentalStyled, Toolbar } from '@mui/material';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { getAvatarName } from '../../helpers/helpers';
// import LanguagePopover from './LanguagePopover';
import { useAuth } from '../../hooks/useAuth';

interface DashboardNavbarProps extends AppBarProps {
    onSidebarMobileOpen?: () => void;
}

const DashboardNavbarRoot = experimentalStyled(AppBar)(() => ( {
    zIndex: 1100,
    background: 'linear-gradient(135deg, #2b1f86 0%, #4531e1 100%)',
    boxShadow: '0 4px 20px rgba(43, 31, 134, 0.2)',
    backdropFilter: 'blur(10px)',
} ));

const DashboardNavbar: FC<DashboardNavbarProps> = (props) => {
    const { onSidebarMobileOpen, ...other } = props;
    const { t } = useTranslation();
    const { userName } = useAuth();
    const auth = useAuth();

    const handleLogout = async () => {
        await auth.logout();
    };

    return (
        <DashboardNavbarRoot { ...other }>
            <Toolbar sx={ { minHeight: 64, px: 3 } }>
                <Box sx={ { ml: 1 } }>
                    { userName && (
                        <Avatar 
                            sx={ { 
                                height: 40, 
                                width: 40,
                                background: 'rgba(255, 255, 255, 0.2)',
                                border: '2px solid rgba(255, 255, 255, 0.3)',
                                fontWeight: 600,
                                fontSize: '0.875rem',
                            } }
                        >
                            { getAvatarName(userName) }
                        </Avatar>
                    ) }
                </Box>
                <Box sx={ { flexGrow: 1, ml: 2 } } />
                {/* <LanguagePopover /> */ }
                <Box sx={ { p: 1 } }>
                    <Button 
                        variant="contained" 
                        onClick={ handleLogout }
                        sx={{
                            background: 'rgba(255, 255, 255, 0.2)',
                            color: '#ffffff',
                            backdropFilter: 'blur(10px)',
                            border: '1px solid rgba(255, 255, 255, 0.3)',
                            '&:hover': {
                                background: 'rgba(255, 255, 255, 0.3)',
                                transform: 'translateY(-2px)',
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
                            },
                        }}
                    >
                        { t('account_logout') }
                    </Button>
                </Box>
            </Toolbar>
        </DashboardNavbarRoot>
    );
};

export default DashboardNavbar;
